module.exports = __webpack_public_path__ + "static/img/success13.72e6046f.png";